import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';
import { take } from 'rxjs';
import { Members } from 'src/app/models/members.model';
import { DbService } from './db.service';

const USER_APP_ID = '8fb2dabb-512d-49c2-81b5-a8a7553fb237';
const USER_ANDROID_CHANNEL_ID = '55de04a6-bb52-4994-a03d-692de6f010b6';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(
    private oneSignal: OneSignal,
    private httpClient: HttpClient,
    private db: DbService
  ) {}

  // 알림내역에 쌓이지 않음
  sendPush(pushId: Array<string>, message: string, data?: any) {
    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };
      let body = {
        //push 정보
        app_id: USER_APP_ID,
        headings: { en: '드림체인' },
        contents: { en: message },
        data: { url: data.url, type: data.type },
        include_player_ids: pushId,
        android_channel_id: USER_ANDROID_CHANNEL_ID,
        ios_badgeType: 'Increase',
        ios_badgeCount: 1,
      };

      if (pushId.length > 0) {
        //로그인을 했을 경우에만
        this.httpClient
          .post('https://onesignal.com/api/v1/notifications', body, httpOptions)
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {
              reject(error);
            }
          );
      }
    });
  }

  // 회원에게 push와 알림 보내기
  memberPush(obj, uuid) {
    this.db
      .collection$(`members`, (ref) =>
        ref.where('exitSwitch', '==', false).where('uuid', '==', uuid)
      )
      .pipe(take(1))
      .subscribe(async (datas: Members[]) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            if (ele.pushId.length > 0) {
              this.sendPush(ele.pushId, obj.content, {
                url: obj.link,
                type: obj.type,
              });
            }
          }
        }
      });
  }

  getId() {
    return new Promise((resolve, reject) => {
      this.oneSignal.getUserId().then((playerId) => {
        resolve(playerId);
      });
    });
  }
}
